// extracted by mini-css-extract-plugin
export default {"storyDetailHeaderDescription":"c-r_hi","storyDetailHeaderDescription__time":"c-r_hj"};